import GlassFrogModel from 'legacy/GlassFrog/GlassFrogModel'

const Announcement = GlassFrogModel.extend({}, {
  resourceName: 'announcements',
})

export default Announcement
